<template>
<div class="ccpay-supmetdetail">
         <div class="ccpay-supmetdetail-header">
                <span @click="back"> 返回</span>
                <span >法币补充</span>
                <span></span>
         </div>
         <div class="ccpay-supmetdetail-connect">
            <ul style="background:#white">
                <li class="ccpay-supmetdetail-type">
                    <div class="selectTime" @click="selectData">
                    <span >选择时间：</span>
                    <span>{{this.selectedValue}}</span>
                    </div>
                </li>
                 <li class="ccpay-supmetdetail-type">
                  <input class="phoneNum phoneNumTull-lv app-Recharge-number" v-model="price" v-on:input="blurbumber"   placeholder="补充金额" type="number" 
                 ></input>
               
                </li>
                 <li class="ccpay-supmetdetail-type">
                 <input class="phoneNum phoneNumTull-lv app-Recharge-number" v-model="fee" v-on:input="blurfee"  placeholder="手续费" type="number" 
                 ></input>
                
                </li>
                  
                <li >
                    <div class="ccpay-add-img " >
                        <p class="sup-tec" style="font-size: 16px;">截图</p>
                        <div class="imgactive" v-show="src!==''">
                             <img    style="width:100px;height:100px;object-fit: contain;" :src="src"/>
                             <span class="imgactiveafter" @click="removeimg">x</span>
                        </div>
                         <input
                            v-show="src==''"
                            multiple
                            type="file"
                            accept="image/*"
                            class="img-btn"
                            ref="ipt"
                            @change="updateImg"
                        />
                    </div>
                </li> 
               
                 <li>
                  <mt-field class="phoneNum phoneNumTull-lv"  
                   placeholder="备注" 
                    v-model="remark"
                    ></mt-field>
                </li>
           
              <li >
                    <mt-button class="mt-40" size="large" type="primary" 
                        @click="submit()">补充</mt-button>
                </li>
                 </ul>
         </div>
    
  <div class="pickerDemo">
       <!-- <div class="showTime">
            <p class="timeDes">当前时间是：{{this.selectedValue}}</p>
            <div class="selectTime" @click="selectData">选择时间</div>
        </div>-->
        <!-- @touchmove.prevent 阻止默认事件，此方法可以在选择时间时阻止页面也跟着滚动。 -->
        <div class="pickerPop" @touchmove.prevent>
            <!-- 年月日时分选择 -->
            <mt-datetime-picker
                lockScroll="true"
                ref="datePicker"
                v-model="dateVal"
                class="myPicker"
                type="datetime"
                year-format="{value}"
                month-format="{value}"
                date-format="{value}"
                hour-format="{value}"
                minute-format="{value}"
                second-format="{value}"
                @confirm="dateConfirm()">
            </mt-datetime-picker>
        </div>
    </div>
    </div>
</template>
 
<script>
import { Indicator } from 'mint-ui';
import moment from  "moment"
import Vue from 'vue'
import AWS from 'aws-sdk'
export default {
    name: 'pickerDemo',
    data () {
        return {
            dateVal: '', // 默认是当前日期
            selectedValue: '',
            fund_id:'',//id
            type:'',//类型
            price:'',//均价
            fee:'',//费率
            src:'',//img路径
            remark:'',//补充
            typeList:[
                {id:1,name:'对冲'},
                {id:2,name:'借调'},
                {id:3,name:'出入金'},
            ],
            selected:'',
            file:'',
            awssrc:''
        }
    },
    components: {
    },
    created () {
    },
    mounted () {
        let that = this
        this.fund_id= this.$route.query.fund_id
        
    },
    methods: {
        selectData () { // 打开时间选择器
            // 如果已经选过日期，则再次打开时间选择器时，日期回显（不需要回显的话可以去掉 这个判断）
            if (this.selectedValue) {
                this.dateVal = this.selectedValue
            } else {
                this.dateVal = new Date()
            }
            this.$refs['datePicker'].open()
        },
        dateConfirm () { // 时间选择器确定按钮，并把时间转换成我们需要的时间格式
            this.selectedValue = moment(this.dateVal).format("YYYY-MM-DD HH:SS")
        },
        getTypeSelected(){
            // this.selected = this.selected
            // console.log(this.selected)
        },
        blurbumber(){
            if(this.price==''){
                this.price = ''
                return
            }
            
            if(this.price<0){
                
                let absprice = -(this.price)
                this.price = '-' + absprice.toString().match(/^\d+(?:\.\d{0,2})?/)[0]
               
               
            }else{
                 let absprice = -(this.price)
                if(absprice=='0'){
                    this.price = 0 
                }else{
                    this.price = this.price.toString().match(/^\d+(?:\.\d{0,2})?/)[0]
                }
               
            }
           
            //  console.log(this.price)
        },
        blurfee(){
            if(this.fee==''){
                this.fee = ''
                return
            }
             if(this.fee<=0){
                this.fee = 0
            }
             let a= this.fee.toString().match(/^\d+(?:\.\d{0,2})?/)[0]
             this.fee =  a
            //  console.log(this.fee)
        },
        back(){
            this.$router.go(-1)
        },
        submit(){
           
            if(this.price==''){
                this.$Toast('请输入均价')
                return
            }
            if(this.fee==''){
                this.$Toast('请输入手续费')
                return
            }
            // if(this.src==''){
            //     this.$Toast('请上传截图')
            //     return
            // }
            if(this.remark==''){
                this.$Toast('请填写备注')
                return
            }
            if(this.src==''){
                this.otosubmit()
            }else{
                 this.AWSupdateImg()
            }
           
        },
        otosubmit(){
            Indicator.open();
            // console.log(this.price,this.fee,this.awssrc,this.awssrc,this.selectedValue,this.remark)

             
             this.$axios.post('/v1/traders_profit/legal_fund_ex_info/append',{
                "legal_currency": "CNY",
                "amount": this.price,
                "fee": this.fee,
                "img": this.awssrc,
                "time": this.selectedValue,
                "remark": this.remark
            }).then(res=>{
                Indicator.close();
                if(res.code==0){
                    this.$router.go(-1)
                     this.$Toast(res.msg)
                }else{
                     this.$Toast(res.msg)
                }
            })
        },
        randomString(len){
            //默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
            var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
            var tempLen = chars.length, tempStr='';
            for(var i=0; i<len; ++i){
                tempStr += chars.charAt(Math.floor(Math.random() * tempLen ));
            }
            return tempStr;
        },
        //上传头像
        AWSupdateImg(e){
             Indicator.open();
             let file = this.file
             let str = Math.random().toString(36).substr(2).slice(0,5)
             var nowtime = moment().format("YYMMDDHHmm") +  str
            //   console.log(nowtime )   ;
            
             let filename = 'trader/fund/'+ nowtime + this.randomString(20) +'.png' 
            //  console.log(file)
             let s3 = new AWS.S3({
                'accessKeyId' : 'AKIAREVQNU3CEQHLNE63',
                'secretAccessKey' : '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',
                Region: 'ap-northeast-1',
                // 'sessionToken' : 'ap-northeast-1'
              });
            let params = {
                Bucket: 'otcc-privacy-resource', /* required */
                Key:filename, /* required */
                Body: file,
                'Access-Control-Allow-Credentials': '*',
                'ACL': 'public-read',
            };
            s3.upload(params, (err, data) =>{
                 Indicator.close();
             if (err) {
                  this.$Toast('图片上传失败')
            } else {
                 let src = s3.getSignedUrl('getObject', {Bucket: 'otcc-privacy-resource',Key:filename})
                 this.awssrc =   src.split('?')[0]
                 this.otosubmit()
            }
           })
        },
       
        //删除头像
        removeimg(){
            this.src = ''
            this.file = ''
        },
         //上传头像
        updateImg(e){
           
             this.file = e.target.files[0]
             this.imgUpLoad(e.target.files);
        },
        //获取路径
        imgUpLoad(allFile){
           
            let file = allFile[0];
            let reader = new FileReader();
            let config = {
                headers: {
                "Content-Type": "multipart/form-data"
                }
            };
              console.log(file,'file')
            reader.readAsDataURL(file); //用文件加载器加载文件
            reader.onload = e => {
                // let img = new Image();
                // img.src = e.target.result;
                this.src = e.target.result;
                // console.log(e.target.result,'e.target.result')
            };
        },
    }
}
</script>
 
<style scoped lang="scss">
    .pickerDemo{
        width: 100%;
        height: 18rem;
        // background-color: #ccc;
        .showTime{
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 2rem;
            .timeDes{
                font-size: 0.4rem;
                color: red;
            }
            .selectTime{
                display: inline-block;
                width: 4rem;
                height: 1rem;
                line-height: 1rem;
                text-align: center;
                background-color: #ff776d;
                color: #fff;
                font-size: 0.24rem;
                border-radius: 8px;
                margin-top: 1rem;
            }
        }
    }
    .pickerPop{
        /deep/ .picker{
            .picker-toolbar{
                background-color: #eee;
                .mint-datetime-action{
                    font-size: 0.26rem;
                    color: #000!important;
                }
            }
        }
    }

    .ccpay-supmetdetail{
        .ccpay-supmetdetail-type{
            position: relative;
             padding:0 10px;
            color: #666;
            font-size: 0.93rem;
            border-bottom: 1px solid;
            border-color: #eee;
            // height: 3re;
            background: white;
            height: 3rem;
            line-height: 3rem;
            select{
                    height:30px;
                    border:none;
                    background: white;
                    width: 50%;
                    outline: none;
                    option{
                        // height: 2rem;;
                        // line-height: 4rem;
                    }
            }
        }
        .sup-tec{
             color: #888;
            text-align: center;
            line-height: 3rem;
        }
         height: 100%;
         background: #f8f8f8;
         .ccpay-supmetdetail-header{ 
                height: 3rem;
                line-height: 3rem;
                width: 100%;
                position: fixed;
                background: white;
                display: flex;
                justify-content: space-between;
                span:nth-of-type(1){
                    margin-left: 1rem
                }
                span:nth-of-type(3){
                    margin-right: 1rem
                }
         }
         .ccpay-supmetdetail-connect{
              padding-top: 4rem;
             padding-left:1rem;
             padding-right:1rem;
         }
         .ccpay-add-img{
        // background: white;
        // margin-top: 1rem;
        margin-bottom: 5rem;
        position: relative;
        // display: flex;
        width: 100%;
        height: 100px;;
        .imgactive{
            position: absolute;
            width: 100px;
            height: 100px;
            left: 50%;;
            margin-left: -50px;
        }
        .imgactiveafter{
             position: absolute;
             right: -20px;
            top: 0;
            padding-left: 2px;
            padding-right: 2px;
            font-size: 1.2rem;
            color: #ccc;
        }
        input{
            position: absolute;
            width: 100px;
            height: 100px;
            left: 50%;;
            margin-left: -50px;
        }
    }
    .ccpay-add-img .img-btn {
        border: none !important;
        overflow: hidden;
    }
    .ccpay-add-img .img-btn::after {
        content: "";
        padding: 0 !important;
        background: url("../../../static/mobile_img/addimg.png") #fff;
        width: 100px;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        // z-index: 1;
        background-size: cover;
    }
    .ccpay-resadd-img{
        margin-bottom: 1rem;
        display: flex;
        justify-content: center;
        button{
             background: #ccc;
            padding: 6px;
            outline: none;
            border: none;
            color: white;
        }
    }
    .app-Recharge-number{
            font-size: 16px;
            font-weight: 400 !important;
            font-family: inherit;
            line-height: 2.3rem !important;
            outline: none;
            padding: 0 10px;
            // margin-left: 0.4rem !important;
            width: 95%;
                border: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/my/Frenchhistorydetail.vue